<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-xl-row align-items-center justify-content-between gap-3 mb-4" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center">
          <div class="header-icon-wrapper mr-3" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);">
            <i class="fa fa-money text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Listagem Contas a Receber</h4>
            <span class="text-muted small">Gerencie seus títulos e recebimentos</span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <!-- Filtro Consolidado Premium -->
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border">
            <b-button-group class="mr-1">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="CSV">
                <i class="fa fa-file-text-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-info" @click="abrirModalBaixarLote()" v-b-tooltip.hover title="Baixar em Lote">
                <i class="fa fa-university"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-info" @click="abrirPainelAnalitico()" v-b-tooltip.hover title="Painel Analitico">
                <i class="fa fa-line-chart"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-1">
              <cec-input-data ref="dt1" v-model="dt1" class="mx-1" style="width: 140px" placeholderText="Início" @keydown.enter.native="pesquisar()" />
              <span class="text-muted mx-1">até</span>
              <cec-input-data v-model="dt2" class="mx-1" style="width: 140px" placeholderText="Fim" @keydown.enter.native="pesquisar()" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-1">
               <b-form-select class="border-0 bg-transparent py-0" v-model="situacao" :options="optionsSituacao" style="width: 150px;" @keydown.enter.native="pesquisar()" />
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>

          <b-button variant="info" pill class="px-4 ml-2 font-weight-bold shadow-sm text-white" @click="novo()">
            <i class="fa fa-plus-circle mr-1"></i> Novo Título
          </b-button>
        </div>
      </div>

      <!-- Filtros Avançados Modernos -->
      <b-collapse v-model="filtro.avancado">
        <b-card class="card-filter-premium mb-4 border-0 shadow-sm" :class="{'bg-dark text-white': isDark}">
          <div class="modal-section-title mb-3" :class="{'text-white border-secondary': isDark}">Parâmetros Adicionais de Filtro</div>
          <b-row align-v="end">
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Nº Documento</label>
              <b-form-input v-model="documento" placeholder="Ex: 12345" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Nº Controle (ID)</label>
              <b-form-input v-model="id" placeholder="Ex: 987" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Período por</label>
              <b-form-select v-model="situacao" :options="optionsSituacao" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="6">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Cliente</label>
              <cliente-pesquisa 
                @retornaId="clienteId = $event"
                :idInicial="clienteId"
                label=""
                place="Informe o Cliente..."
                labelBotao=""
                ref="clientepesquisa"
                idModal="clientepesquisa"
                input-class="rounded-pill shadow-xs border-0 bg-light"
                @keydown.enter.native="pesquisar()"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

      <!-- Resumo Financeiro Premium -->
      <b-row class="mb-4 px-3">
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-primary" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Títulos</div>
            <div class="h4 mb-0 font-weight-bold">{{ quantTitulos }}</div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-info" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Total Títulos</div>
            <div class="h4 mb-0 font-weight-bold">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalTitulos" tag="span" />
            </div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-success" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Em Dias</div>
            <div class="h4 mb-0 font-weight-bold text-success">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalEmDias" tag="span" />
            </div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-danger" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Atrasados</div>
            <div class="h4 mb-0 font-weight-bold text-danger">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalAtrasado" tag="span" />
            </div>
          </div>
        </b-col>
      </b-row>
            <!--  -----------------------------------------------------------------------------------
                                            TABELA DE LISTAGEM - FILTRO 
                  ----------------------------------------------------------------------------------- -->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">              
            <b-table 
                      class="mb-0 table-finance"
                      id="tbl-principal"
                      ref="tbl"
                      show-empty
                      empty-text="Informe o filtro para ver os pesquisas "
                      :dark="isDark"
                      small
                      responsive 
                      :tbody-tr-class="rowClassSelecionado"
                      :head-variant="isDark ? 'dark' : 'light'"
                      hover 
                      :sticky-header="stickyHeight"
                    @row-clicked="clicarLinha"
                    @row-dblclicked="edit"
                    :items="itensFiltrados" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    
                    >
              <!-- Cabeçalho: DOCUMENTO -->
              <template #head(DOCUMENTO)>
                <SetFilter
                  label="Documento"
                  v-model="filtros.DOCUMENTO"
                  :options="opcoes.DOCUMENTO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <!-- Cabeçalho: Situação -->
              <template #head(PARCELA)>
                <SetFilter
                  label="Parcela"
                  v-model="filtros.PARCELA"
                  :options="opcoes.PARCELA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(NOME_CLIENTE)>
                <SetFilter
                  label="Cliente"
                  v-model="filtros.NOME_CLIENTE"
                  :options="opcoes.NOME_CLIENTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              
              <template #head(ITENS)>
                <SetFilter
                  label="Descricao"
                  v-model="filtros.ITENS"
                  :options="opcoes.ITENS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(DT_DOC)>
                <SetFilter
                  label="Doc"
                  v-model="filtros.DT_DOC"
                  :options="opcoes.DT_DOC"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(DT_RECEB)>
                <SetFilter
                  label="Vencimento"
                  v-model="filtros.DT_RECEB"
                  :options="opcoes.DT_RECEB"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(VL_AJUSTE)>
                <SetFilter
                  label="VL. Ajuste"
                  v-model="filtros.VL_AJUSTE"
                  :options="opcoes.VL_AJUSTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #cell(DIAS_ATRASO)="item">
                <b-badge pill :variant="colorirDiasAtraso(item.item.DIAS_ATRASO)">{{item.item.DIAS_ATRASO}}</b-badge>
              </template>      
              <template #cell(OP_STATUS_BOLETO)="item">
                <i v-if="((item.item.OP_STATUS_BOLETO) && (item.item.OP_STATUS_BOLETO.trim() != '0'))" class="fa fa-barcode"></i>
                <i v-if="item.item.OP_STATUS_BOLETO != '0'" :class="classIconeBoleto(item.item.OP_STATUS_BOLETO)"></i>
              </template>      
              <template #cell(SIGLA_CONTA_BOLETO)="item">
                {{item.item.SIGLA_CONTA_BOLETO}}
              </template>
              
              <template #cell(NOME_CLIENTE)="item">
                <div class="font-weight-bold text-dark">{{ item.item.NOME_CLIENTE }}</div>
                <small class="text-muted">Cód: {{ item.item.COD_CLI }}</small>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1">
                  <b-button v-if="(item.item.VL_DOC !== item.item.VL_ARECEBER)"
                        type="button" @click.stop.prevent="abrirModalRecebimentos(item.item)" size="sm" variant="soft-primary" pill class="btn-icon-only shadow-sm mr-1" title="Recebimentos" v-b-tooltip.hover.left>
                    <i class="fa fa-exchange"></i>
                  </b-button>

                  <b-button  type="button" @click="abrirModalCancelamento(item.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm mr-1" title="Cancelar Titulo" v-b-tooltip.hover.left>
                    <i class="fa fa-close"></i>
                  </b-button>
                  <b-button  type="button" @click="abrirModalBaixar(item.item)" size="sm" variant="soft-success" pill class="btn-icon-only shadow-sm mr-1" title="Baixar Titulo" v-b-tooltip.hover.left>
                    <i class="fa fa-money"></i>
                  </b-button>

                  <b-dropdown
                      right
                      dropup
                      boundary="viewport"
                      :popper-opts="{ positionFixed: true }"
                      no-caret
                      variant="link"
                      toggle-class="p-0 text-muted no-decoration"
                      @shown="clicarMenuLinha(item.item)"
                  >
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>

                    <b-dropdown-item v-if="((item.item.OP_STATUS_BOLETO) && (item.item.OP_STATUS_BOLETO.trim() != '0'))" @click="downloadBoleto(item.item)"><i class="fa fa-eye text-primary"></i> Visualizar Boleto</b-dropdown-item>
                    <b-dropdown-item v-else @click="abrirModalGerarBoleto(item.item)"><i class="fa fa-barcode text-info"></i> Gerar Boleto</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="cancelarBoleto(item.item)"><i class="fa fa-close text-danger"></i> Cancelar Boleto</b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
              <!-- Alternativamente, usando custom-foot para linha de rodapé completa -->
              <template #custom-foot="{ fields, items }">
                <b-tr>
                  <b-td>Itens: ({{ itensFiltrados.length }})</b-td>
                  <b-td class="text-right font-weight-bold" v-for="(field, idx) in fields.slice(1)" :key="idx">
                    <!-- supondo que "campoValor" seja a key da coluna cujo total você quer -->
                    <span class="text-right font-weight-bold" v-if="field.key === 'VL_ARECEBER'">{{ vlAreceberRodape }}</span>
                    <span class="text-right font-weight-bold" v-if="field.key === 'VL_AJUSTE'">{{ vlAjusteRodape }}</span>
                    <span class="text-right font-weight-bold" v-if="field.key === 'VL_DOC'">{{ vlDocRodape }}</span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
      <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL RECEBIMENTOS 
              ----------------------------------------------------------------------------------- -->
          <b-modal ref="modal-baixar" 
              id="modal-baixar" 
              hide-header
              hide-footer
              body-class="p-0 overflow-hidden"
              content-class="border-0 shadow-lg"
              centered 
              size="lg"
              @shown="focusModalReceber()" 
          >
            <b-overlay :show="overlayBaixando" 
                        no-wrap 
                        fixed 
                        z-index="1100" 
                        spinner-variant="primary"
                        spinner-type="border">
              <template #overlay>
                <div class="text-center bg-white p-4 rounded shadow-lg border">
                  <b-icon icon="stopwatch" font-scale="3" class="text-primary mb-3" animation="cylon"></b-icon>
                  <h5 class="font-weight-bold">Processando Recebimento...</h5>
                  <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
                </div>
              </template>
            </b-overlay>

            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-money text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Baixar Título a Receber</h5>
                    <small class="text-white opacity-75">Confirmação de entrada financeira no caixa/banco</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-baixar')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <div class="p-4 bg-white">
                <!-- Modal Info Bar -->
                <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                    <b-row align-v="center">
                        <b-col md="6">
                            <small class="modal-label-premium">Cliente Pagador</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{recebido.nomeCliente}}</h5>
                        </b-col>
                        <b-col md="3" class="border-left">
                            <small class="modal-label-premium">Documento / Venc.</small>
                            <h5 class="mb-0 font-weight-bold text-primary">{{recebido.documento}}</h5>
                            <small class="text-muted font-weight-bold">{{recebido.dataVencimento}}</small>
                        </b-col>
                        <b-col md="3" class="border-left text-right">
                            <small class="modal-label-premium">Valor Original</small>
                            <h5 class="mb-0 font-weight-bold text-success">{{formatCurrency(recebido.valorDocumento)}}</h5>
                        </b-col>
                    </b-row>
                </div>

                <div v-if="modalRecebimentos.parametros.permissao === true">
                    <div class="modal-section-title mb-3">
                        <i class="fa fa-cogs mr-2 text-primary"></i> Detalhes do Recebimento
                    </div>
                    
                    <div class="p-4 bg-light rounded border shadow-xs mb-4">
                        <b-row class="mb-3">
                            <b-col md="6">
                                <label class="modal-label-premium">Tipo de Recebimento</label>
                                <b-form-select id="tiporecebimento" ref="tiporecebimento"
                                    v-model="recebido.tipoRecebimento"
                                    :options="tipoRecebimentoOpcoes"
                                    class="rounded-pill shadow-xs"
                                ></b-form-select>
                            </b-col>
                            <b-col md="6">
                                <label class="modal-label-premium">Data do Recebimento</label>
                                <b-form-input type="date" 
                                    id="dataBaixa" 
                                    v-model="recebido.dataMovimento"
                                    class="rounded-pill shadow-xs"
                                ></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col md="6">
                                <label class="modal-label-premium">Valor Recebido R$</label>
                                <div class="d-flex gap-2">
                                    <vue-autonumeric
                                        id="valorRecebido" 
                                        ref="valorRecebido"
                                        v-model="recebido.valorRecebido"
                                        :options="'Brazilian'"
                                        :class="['form-control rounded-pill shadow-xs', { 'is-invalid': !validouCamposGeralBaixa }]" 
                                        style="text-align: right"
                                    ></vue-autonumeric>
                                    <b-button variant="soft-primary" pill class="px-3 font-weight-bold" @click="usarRestante()" title="Usar valor restante">
                                        <i class="fa fa-magic"></i>
                                    </b-button>
                                </div>
                            </b-col>
                            <b-col md="6">
                              <label class="modal-label-premium">Ajustes R$</label>
                              <vue-autonumeric  
                                id="valorAjustes" 
                                v-model="recebido.valorAjustes" 
                                :options="'Brazilian'" 
                                class="form-control rounded-pill shadow-xs" 
                                style="text-align: right"
                              ></vue-autonumeric>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                                <label class="modal-label-premium">Conta de Destino</label>
                                <b-form-select   
                                    v-model="recebido.contaId" 
                                    :options="contasOpcoes" 
                                    :state="!!recebido.contaId"
                                    ref="comboconta"
                                    class="rounded-pill shadow-xs"
                                >
                                    <template slot="first">
                                        <option :value="null">-- Selecione a conta bancária --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <!-- Campos específicos para PIX -->
                        <div v-if="recebido.tipoRecebimento === '6'" class="mt-3">
                            <div class="modal-section-title mb-3">
                                <i class="fa fa-qrcode mr-2 text-primary"></i> Dados do PIX
                            </div>
                            
                            <b-row class="mb-3">
                                <b-col md="6">
                                    <label class="modal-label-premium">Tipo de Chave PIX <span class="text-danger">*</span></label>
                                    <b-form-select
                                        v-model="recebido.tipoChavePix"
                                        :options="tipoChavePixOpcoes"
                                        :state="!!recebido.tipoChavePix"
                                        class="rounded-pill shadow-xs"
                                    >
                                        <template slot="first">
                                            <option :value="null">-- Selecione o tipo de chave --</option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                                <b-col md="6">
                                    <label class="modal-label-premium">Nome do Pagador</label>
                                    <b-form-input
                                        v-model="recebido.nomePagadorPix"
                                        placeholder="Nome completo do pagador"
                                        class="rounded-pill shadow-xs"
                                        maxlength="100"
                                    ></b-form-input>
                                </b-col>
                            </b-row>

                            <b-row class="mb-3">
                                <b-col md="12">
                                    <label class="modal-label-premium">Banco de Origem</label>
                                    <b-form-select
                                        v-model="recebido.bancoPixId"
                                        :options="bancosPixOpcoes"
                                        class="rounded-pill shadow-xs"
                                    >
                                        <template slot="first">
                                            <option :value="null">-- Selecione o banco de origem --</option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </div>
                    </div>

                    <div class="modal-section-title mb-3">
                        <i class="fa fa-money mr-2 text-primary"></i> Resumo de Saldos
                    </div>
                    
                    <b-row>
                      <b-col md="3">
                            <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                                <small class="modal-label-premium">Vlr. Original</small>
                                <h5 class="mb-0 font-weight-bold text-dark">{{formatCurrency(recebido.valorDocumento)}}</h5>
                            </div>
                        </b-col>
                      <b-col md="3">
                            <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                                <small class="modal-label-premium">Já Recebido</small>
                                <h5 class="mb-0 font-weight-bold text-info">{{formatCurrency(recebido.valorRecebimentos)}}</h5>
                            </div>
                        </b-col>
                      <b-col md="3">
                        <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                          <small class="modal-label-premium">Ajustes</small>
                          <h5 class="mb-0 font-weight-bold text-warning">{{formatCurrency(recebido.valorAjustes)}}</h5>
                        </div>
                      </b-col>
                      <b-col md="3">
                            <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-success border-2">
                                <small class="modal-label-premium text-success">Vlr. Restante</small>
                                <h4 class="mb-0 font-weight-bold text-success">{{formatCurrency(recebido.valorRestante)}}</h4>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div v-else class="alert bg-soft-danger border-danger text-danger text-center p-4 rounded-lg shadow-xs">
                    <i class="fa fa-lock fa-3x mb-3"></i>
                    <h4 class="font-weight-bold mb-1">ACESSO NEGADO</h4>
                    <p class="mb-0">Você não possui permissões suficientes para realizar a baixa deste título.</p>
                </div>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
                <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-baixar')">
                    CANCELAR
                </b-button>
                <b-button v-if="modalRecebimentos.parametros.permissao === true" variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="baixar()">
                    <i class="fa fa-check-circle mr-1"></i> CONFIRMAR RECEBIMENTO
                </b-button>
            </div>
          </b-modal>
      </div>
    </div>
      <!--  -----------------------------------------------------------------------------------
                                        MODAL RECEBIMENTOS 
            ----------------------------------------------------------------------------------- -->
      <div>
          <b-modal ref="modal-recebimentos" 
              id="modal-recebimento" 
              hide-header
              hide-footer
              body-class="p-0 overflow-hidden"
              content-class="border-0 shadow-lg"
              centered 
              size="lg"
          >
            <b-overlay :show="parametrosOverlayRecebimento.busy" 
                            no-wrap 
                            @shown="onShownOverlayRecebimentos()">
                  <template #overlay>
                    <div v-if="parametrosOverlayRecebimento.processando" class="text-center p-4">
                      <b-icon icon="icon-clock" font-scale="4"></b-icon>
                      <div class="mb-3">Processando a requisição...</div>
                      <div class="d-flex justify-content-center mb-3">
                          <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </div>
                    <div
                      v-else
                      ref="dialogOverlayRecebimentos"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3">
                      <b-row>
                        <b-col sm="3">
                          <strong>DOCUMENTO: </strong> 
                        </b-col>
                        <b-col sm="2">
                            {{parametrosOverlayRecebimento.documento}} 
                        </b-col>
                        <b-col sm="2">
                            <strong>PARCELA: </strong>
                        </b-col>
                        <b-col sm="1">
                          {{parametrosOverlayRecebimento.parcela}}
                        </b-col>
                        <b-col sm="2">
                          <strong>VALOR:</strong>
                        </b-col>
                        <b-col sm="2">
                           {{parametrosOverlayRecebimento.valor}}
                        </b-col>
                      </b-row>
                      <div v-if="parametrosOverlayRecebimento.permissao">
                        <p ><strong>PERMISSÂO PARA ESTORNAR AUTORIZADA</strong></p>
                        <hr>
                        <b-form-input  type="text" 
                                      placeholder="Informe o Motivo mín(10 letras)" 
                                      :state="valMotivoEstorno"
                                      v-model="parametrosOverlayRecebimento.motivo"> 
                        </b-form-input>
                        <hr>
                      </div>
                      <div v-else>
                        <p><strong>NÃO TEM PERMISSAO PARA ESTORNAR!!!!</strong></p>
                        <hr>
                      </div>
                      <div class="text-center">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancelOverlayRecebimentos()">
                          Voltar
                        </b-button>
                        <b-button v-if="parametrosOverlayRecebimento.permissao" variant="outline-success" @click="onEstornar()">Estornar</b-button>
                      </div>
                    </div>
                  </template>
            </b-overlay>

            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-list text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Histórico de Recebimentos</h5>
                    <small class="text-white opacity-75">Lista detalhada de baixas efetuadas no título</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-recebimento')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>
          
            <div class="p-4 bg-white">
                 <div class="modal-section-title mb-3">
                    <i class="fa fa-history mr-2 text-primary"></i> Transações Registradas
                </div>

                <div class="bg-white rounded border shadow-xs overflow-hidden">
                    
                <!--  -----------------------------------------------------------------------------------
                                            TABELA DE RECEBIMENTOS
                      ----------------------------------------------------------------------------------- -->
            
                <b-table class="mb-0 table-finance"
                        show-empty
                        empty-text="Nenhum recebimento registrado"
                        small
                        responsive 
                  :head-variant="isDark ? 'dark' : 'light'"
                  :table-variant="isDark ? 'primary' : 'light'"
                  hover 
                        :items="tableRecebimentosItens" 
                        :fields="tableRecebimentosFields"
                        :current-page="currentPageRecebimentos"
                        :per-page="perPageRecebimentos"
                        :filter="filter"
                        :no-border-collapse="teste"
                        >
                  <template #cell(VL_MULTA)="item">
                    <div v-if="(Number(item.item.VL_MULTA) || 0) > 0 || item.item.MULTA" class="text-right">
                      <div class="font-weight-bold text-danger">{{ formatCurrency(item.item.VL_MULTA || 0) }}</div>
                      <small v-if="item.item.MULTA" class="text-muted d-block">{{ item.item.MULTA }}</small>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </template>
                  <template #cell(VL_DESCONTO)="item">
                    <div v-if="(Number(item.item.VL_DESCONTO) || 0) > 0 || item.item.OBS_DESCONTO" class="text-right">
                      <div class="font-weight-bold text-success">{{ formatCurrency(item.item.VL_DESCONTO || 0) }}</div>
                      <small v-if="item.item.OBS_DESCONTO" class="text-muted d-block">{{ item.item.OBS_DESCONTO }}</small>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </template>
                  <template #cell(actions)="item">
                    <b-button type="button" @click.stop.prevent="onAbrirOverlayRecebimentos(item.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Estornar" v-b-tooltip.hover.left >
                      <i class="fa fa-times"></i>
                    </b-button>
                  </template>
                  <!-- The original foot slots seem a bit verbose, I'll keep them but might need verify functionality.
                       Normally modernization involves simplifying tables. --> 
                  <template #foot(VL_BAIXA)="">
                    <span class="font-weight-bold">TOTAL: {{somaTotalRecebido}}</span>
                  </template>
                  <template #foot(DT_BAIXA)="">
                    {{ }}
                  </template>
                  <template #foot(USUARIO)="">
                    {{ }}
                  </template>
                  <template #foot(actions)="">
                    {{ }}
                  </template>
                </b-table>
              </div>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top text-right">
                <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="$bvModal.hide('modal-recebimento')">
                    FECHAR HISTÓRICO
                </b-button>
            </div>
            
          </b-modal>
      </div>
      <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL CANCELAMENTO 
              ----------------------------------------------------------------------------------- -->
          <b-modal ref="modal-cancelamento" 
              id="modal-cancelamento" 
              hide-header
              hide-footer
              body-class="p-0 overflow-hidden"
              content-class="border-0 shadow-lg"
              size="lg"
              centered 
              @shown="focusModalCancelamento()" 
          >
            <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                        no-wrap 
                        fixed 
                        z-index="1100" 
                        spinner-variant="danger"
                        spinner-type="border">
              <template #overlay>
                <div class="text-center bg-white p-4 rounded shadow-lg border">
                  <b-icon icon="slash-circle" font-scale="3" class="text-danger mb-3" animation="pulse"></b-icon>
                  <h5 class="font-weight-bold">Cancelando Título...</h5>
                  <p class="text-muted mb-0">Por favor, aguarde o processamento.</p>
                </div>
              </template>
            </b-overlay>
            
            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-close text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Cancelar Título a Receber</h5>
                    <small class="text-white opacity-75">Anulação de documento financeiro</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <div class="p-4 bg-white">
                <div class="modal-info-bar mb-4 bg-soft-danger border border-danger shadow-sm p-3 rounded">
                    <b-row align-v="center">
                        <b-col md="6">
                            <small class="modal-label-premium text-danger">Cliente</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{cancelamento.dados.nomeCliente}}</h5>
                        </b-col>
                        <b-col md="3" class="border-left border-danger-soft">
                            <small class="modal-label-premium text-danger">Documento</small>
                            <h5 class="mb-0 font-weight-bold text-danger">{{cancelamento.dados.documento}} - {{cancelamento.dados.parcela}}</h5>
                             <small class="text-muted font-weight-bold">{{cancelamento.dados.dataVencimento}}</small>
                        </b-col>
                        <b-col md="3" class="border-left border-danger-soft text-right">
                            <small class="modal-label-premium text-danger">Valor</small>
                            <h5 class="mb-0 font-weight-bold text-danger">{{cancelamento.dados.valorDocumento}}</h5>
                        </b-col>
                    </b-row>
                </div>

                <div v-if="cancelamento.parametros.permissao === false" class="alert bg-soft-danger border-danger text-danger text-center p-4 rounded-lg shadow-xs mt-3">
                    <i class="fa fa-lock fa-3x mb-3"></i>
                    <h4 class="font-weight-bold mb-1">ACESSO NEGADO</h4>
                    <p class="mb-0">Você não possui permissões suficientes para realizar o cancelamento deste título.</p>
                </div>

                <template v-else>
                    <div class="modal-section-title mb-3">
                        <i class="fa fa-commenting mr-2 text-danger"></i> Justificativa do Cancelamento
                    </div>
                    <div class="p-3 bg-light rounded border mb-3 shadow-xs">
                         <label class="modal-label-premium">Motivo do Cancelamento <span class="text-danger">*</span></label>
                         <b-form-textarea 
                            type="text" 
                            ref="motivoCancelamento" 
                            id="motivoCancelamento" 
                            v-model="cancelamento.dados.motivo" 
                            :state="valMotivoCancelamento"
                            placeholder="Informe o Motivo (mín. 10 caracteres)"
                            rows="4"
                            class="shadow-xs border-0"
                         ></b-form-textarea>
                         <small class="text-muted mt-2 d-block"><i class="fa fa-info-circle mr-1"></i> Esta informação será registrada para auditoria.</small>
                    </div>
                </template>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
                <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-cancelamento')">
                    VOLTAR
                </b-button>
                <b-button v-if="cancelamento.parametros.permissao === true" variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="cancelar()">
                    <i class="fa fa-check-circle mr-1"></i> CONFIRMAR CANCELAMENTO
                </b-button>
            </div>
          </b-modal>
      </div>
       <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL GERAR BOLETO 
              ----------------------------------------------------------------------------------- -->
          <b-modal ref="modal-boleto-gerar" 
              id="modal-boleto-gerar" 
              hide-header
              hide-footer
              body-class="p-0 overflow-hidden"
              content-class="border-0 shadow-lg"
              centered 
              size="lg"
          >
            <b-overlay :show="overlayBaixando" 
                        no-wrap 
                        fixed 
                        z-index="1100" 
                        spinner-variant="primary"
                        spinner-type="border">
              <template #overlay>
                <div class="text-center bg-white p-4 rounded shadow-lg border">
                  <b-icon icon="stopwatch" font-scale="3" class="text-primary mb-3" animation="cylon"></b-icon>
                  <h5 class="font-weight-bold">Gerando Boleto...</h5>
                  <p class="text-muted mb-0">Comunicação bancária em andamento.</p>
                </div>
              </template>
            </b-overlay>
            
             <!-- Header Premium -->
            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-barcode text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Gerar Título Bancário</h5>
                    <small class="text-white opacity-75">Emissão de boleto para cobrança</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-boleto-gerar')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <div class="p-4 bg-white">
                 <!-- Info Bar -->
                <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                    <b-row align-v="center">
                        <b-col md="8">
                            <small class="modal-label-premium">Cliente Pagador</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{ boleto.clienteId }} - {{ boleto.nomeCliente }}</h5>
                            <small class="text-muted font-weight-bold">Título: {{ boleto.documento }} / {{ boleto.parcela }}</small>
                        </b-col>
                        <b-col md="3" class="border-left text-right">
                            <small class="modal-label-premium text-right">Valor Total</small>
                            <h5 class="mb-0 font-weight-bold text-success">{{formatCurrency(boleto.valorDocumento)}}</h5>
                        </b-col>
                    </b-row>
                </div>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-university mr-2 text-primary"></i> Configurações de Recebimento
                </div>
                
                <div class="p-4 bg-light rounded border shadow-xs mb-4">
                    <b-row class="mb-3">
                      <b-col md="12">
                        <label class="modal-label-premium">Empresa Emitente</label>
                        <b-form-select 
                            v-model="boleto.empresaId"
                            :options="empresas.options" 
                            :state="!!boleto.empresaId"
                            class="rounded-pill shadow-xs"
                        />
                      </b-col> 
                    </b-row>    
                    <b-row >
                      <b-col md="12">
                         <label class="modal-label-premium">Conta para Depósito / Cobrança</label>
                          <b-form-select   
                                          v-model="boleto.contaId" 
                                          :options="contasOpcoes" 
                                          ref="comboconta"
                                          class="rounded-pill shadow-xs"
                                          >
                            <template slot="first">
                              <option :value="null" >-- Selecione a conta bancária --</option>
                            </template>
                          </b-form-select>
                      </b-col>
                    </b-row>
                </div>
                
                 <div class="modal-section-title mb-3">
                    <i class="fa fa-money mr-2 text-primary"></i> Resumo Financeiro
                </div>
                
                <b-row class="mb-0">
                  <b-col sm="4">
                    <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                        <small class="modal-label-premium">Vlr. Original</small>
                        <money  id="valorOriginal" v-model="boleto.valorDocumento" v-bind="formatoMoeda" class="form-control border-0 text-center font-weight-bold text-dark bg-transparent" style="font-size: 1.1rem;" :disabled="true"></money>
                    </div>
                  </b-col>
                  <b-col sm="4">
                     <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                        <small class="modal-label-premium">Recebimentos</small>
                        <money  id="valorRecebimentos" v-model="boleto.valorRecebimentos" v-bind="formatoMoeda" class="form-control border-0 text-center font-weight-bold text-info bg-transparent" style="font-size: 1.1rem;" :disabled="true"></money>
                     </div>
                  </b-col>
                  <b-col sm="4">
                     <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-success border-2">
                         <small class="modal-label-premium text-success">Vlr. à Gerar</small>
                        <money  id="valorrestante" v-model="boleto.valorRestante" v-bind="formatoMoeda" class="form-control border-0 text-center font-weight-bold text-success bg-transparent" style="font-size: 1.2rem;" :disabled="true"></money>
                     </div>
                  </b-col>
                </b-row>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
                <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-boleto-gerar')">
                    CANCELAR
                </b-button>
                <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="gerarBoleto()">
                    <i class="fa fa-barcode mr-1"></i> GERAR BOLETO AGORA
                </b-button>
            </div>
          </b-modal>
      </div>
    
      <ModalAlertaResultadoGrande
        ref="modalConfirmarResultadoGrande"
        :count="resultadoPendenteCount"
        @confirmar="confirmarCarregarResultadoGrande"
        @cancelar="cancelarCarregarResultadoGrande"
        @shown="modalConfirmacaoAberto = true"
        @hidden="modalConfirmacaoAberto = false"
      />
      <!--  -----------------------------------------------------------------------------------
                        MODAL BAIXAR LOTE 
            ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-baixar-lote" 
            id="modal-baixar-lote" 
            size="xl"
            hide-header
            hide-footer
            body-class="p-0"
            centered 
            @shown="focusModalBaixarLote()" 
            title="Baixar em Lote" >
        <b-overlay :show="lote.overlay" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Processando... Aguarde!</p>
            </div>
          </template>
        </b-overlay>

        <b-card :bg-variant="isDark ? 'gray-700' : 'gray-100'">
            <div slot="header">
                <i class='fa fa-money'></i><strong> Baixar Títulos em Lote</strong>
            </div>

            <b-row class="mb-2">
                <b-col sm="6">
                    <cliente-pesquisa 
                        @retornaId="onClienteSelecionadoLote($event)"
                        @retornaNome="lote.nomeCliente = $event"
                        :idInicial="lote.clienteId"
                        label="Cliente"
                        place="Selecione o Cliente"
                        ref="clientepesquisaLote"
                        idModal="clientepesquisaLote">
                    </cliente-pesquisa>
                </b-col>
                <b-col sm="3">
                    <label>Data Movimento</label>
                    <b-form-input type="date" v-model="lote.dataMovimento"></b-form-input>
                </b-col>
                <b-col sm="3">
                    <label>Conta</label>
                    <conta-drop-down v-model="lote.contaId" placeholder="Selecione a Conta"></conta-drop-down>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                 <b-col sm="3">
                    <label>Tipo Recebimento</label>
                     <b-form-select v-model="lote.tipoRecebimento" :options="tipoRecebimentoOpcoes"></b-form-select>
                 </b-col>
                 <b-col sm="3">
                    <label>Valor Total Selecionado</label>
                    <money v-model="lote.valorTotalRecebido" v-bind="formatoMoeda" class="form-control font-weight-bold text-success" style="text-align: right" disabled></money>
                 </b-col>
                 <b-col sm="6" class="text-right pt-4">
                     <b-button variant="danger" class="mr-2" @click="$refs['modal-baixar-lote'].hide()">Cancelar</b-button>
                     <b-button variant="success" @click="confirmarBaixaLote()">Confirma Recebimento</b-button>
                 </b-col>
            </b-row>
            
            <hr>
            
            <b-table 
                small 
                responsive
                striped 
                hover 
                :items="lote.titulos" 
                :fields="loteFields" 
                primary-key="SEQUENCIA"
                :dark="isDark"
                show-empty
                empty-text="Nenhum título encontrado para este cliente.">
                
                <template #head(selecionado)="data">
                    <b-form-checkbox v-model="lote.todosSelecionados" @change="toggleTodosTitulosLote"></b-form-checkbox>
                </template>

                <template #cell(selecionado)="row">
                    <b-form-checkbox v-model="row.item.selecionado" @change="somarSelecionados"></b-form-checkbox>
                </template>

                <template #cell(DT_RECEB)="row">
                    {{ row.item.DT_RECEB | data }}
                </template>

                <template #cell(VL_ARECEBER)="row">
                     {{ row.item.VL_ARECEBER | moeda }}
                </template>
            </b-table>
        </b-card>
      </b-modal>

  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import moment from 'moment'
import {Money} from 'v-money'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import ContaDropDown from '@/views/componentes/dropdown/ContaDropDown.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    ModalAlertaResultadoGrande,
    Money,
    VueAutonumeric,
    SetFilter,
    ContaDropDown,
    CecInputData
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'dados',
    tblRef: 'tbl',
    preferVh: 62,
    useExternalPaging: true,
    filters: [
      { key: 'DOCUMENTO', type: 'string', label: 'Documento' },
      { key: 'PARCELA', type: 'string', label: 'Parcela' },
      { key: 'NOME_CLIENTE', type: 'string', label: 'Cliente' },
      { key: 'ITENS', type: 'string', label: 'Descrição' },
      { key: 'DT_DOC', type: 'date', label: 'Dt. Doc',
        toText: ts => Tools.formatarDataBR(ts) } ,
      { key: 'DT_RECEB', type: 'date', label: 'Vencimento',
        toText: ts => Tools.formatarDataBR(ts) },
      { key: 'VL_AJUSTE', type: 'number', label: 'Vl. Ajuste' },
    ]
  })],

  data () {
    return {
      filtro: {
        avancado: false
      },
      teste: false,
      show: false,
      minimoMoeda: 0,
      overlayBaixando: false,
      overlayRecebimentos: false,
      submmited: false,
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      parametrosOverlayRecebimento: {
        busy: false,
        processando: false,
        counter: 1,
        interval: null,
        permissao: true,
        valor: 0.00,
        parcela: '',
        documento: '',
        recebidoId: null,
        motivo: ''
      },
      lote: {
          overlay: false,
          clienteId: null,
          nomeCliente: '',
          dataMovimento: moment().format('YYYY-MM-DD'),
          contaId: null,
          tipoRecebimento: '0',
          titulos: [],
          valorTotalRecebido: 0.00,
          todosSelecionados: false
      },
      loteFields: [
          { key: 'selecionado', label: '', class: 'text-center' },
          { key: 'DOCUMENTO', label: 'Documento', sortable: true },
          { key: 'PARCELA', label: 'Parc.', sortable: true },
          { key: 'DT_RECEB', label: 'Vencimento', sortable: true },
          { key: 'ITENS', label: 'Descrição' },
          { key: 'VL_ARECEBER', label: 'Valor Aberto', class: 'text-right', sortable: true }
      ],
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      optionsSituacao: [
        { value: '0', text: 'Data do Documento' },
        { value: '1', text: 'Data do Vencimento' }
      ],
      isLoading: false,
      status: '',
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      fields: [
        {
          key: "DOCUMENTO",
          label: 'Documento',
          class:'text-right p-0 align-middle',
          sortable: true
        },
        {
          key: "PARCELA",
          label: 'Parc.',
          class:'p-0 align-middle',
          sortable: true 
        },
        
        {
          key: "OP_STATUS_BOLETO",
          label: 'Boleto',
          sortable: true 
        },
        
        {
          key: "SIGLA_CONTA_BOLETO",
          label: 'Conta',
          class:'p-0 align-middle',
          sortable: true 
        },
        
        {
          key: "ITENS",
          label: 'Descrição',
          class:'p-0 align-middle',
          sortable: true 
        },
        {
          key: "NOME_CLIENTE",
          label: 'Cliente',
          class:'p-0 align-middle',
          sortable: true 
        },
        {
          key: "DT_DOC",
          label: 'Docto.', 
          class:'text-right p-0 align-middle',
          sortable: true,
          formatter: (value, key, item) => 
            Tools.formatarDataBR(value)
        },
        {
          key: "DT_RECEB",
          label: 'Vencimento', 
          class:'text-right p-0 align-middle',
          sortable: true,
          formatter: (value, key, item) => 
            Tools.formatarDataBR(value)
        },
        {
          key: "DIAS_ATRASO",
          label: 'Atrazo',
          class:'text-center p-0 align-middle',
          sortable: true 
        },
        {
          key: 'VL_DOC', 
          class:'text-right p-0 align-middle',
          label: 'Original (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_AJUSTE', 
          class:'text-right p-0 align-middle',
          label: 'Ajustes (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_ARECEBER', 
          class:'text-right p-0 align-middle',
          label: 'Restante (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          tdClass: (value, key, item) => {
              if (item.VL_ARECEBER === item.VL_DOC)
                return ''
              else 
                return 'table-danger'  
            }
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right p-0 align-middle',
          thStyle: { width: "10%" }
        }
      ],
      perPageRecebimentos: 20,
      currentPageRecebimentos: 1,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      tipoRecebimentoOpcoes: [
        { value: '0', text: 'Dinheiro\Carteira' },
        { value: '1', text: 'Depósito Bancário' },
        { value: '2', text: 'Boleto' },
        { value: '3', text: 'Cheque' },
        { value: '4', text: 'Cartão de Crédito' },
        { value: '6', text: 'PIX' }
      ],
      tipoChavePixOpcoes: [
        { value: '0', text: 'CPF/CNPJ' },
        { value: '1', text: 'Celular' },
        { value: '2', text: 'Email' },
        { value: '3', text: 'Aleatória' }
      ],
      bancosPixOpcoes: [],
      empresas: {
        id: null,
        items : [],
        options: [
          { value: null, text: '' }
        ]
      },
      boleto:{
        empresaId: null,
        contaId: null,
        areceberId: null,
        boletoId: null,
        documento: null,
        parcela: null,
        nomeCliente: null,
        clienteId: null,
        valorRecebido: 0.00,
        valorMulta: 0.00,
        valorDesconto: 0.00,
        valorDocumento: 0.00,
        valorRestante: 0.00,
        valorAberto: 0.00
      },
      recebido: {
        areceberId: null,
        documento: null,
        parcela: null,
        clienteId: null,
        nomeCliente: null,
        dataVencimento: "00/00/0000",
        dataMovimento: "00/00/0000",
        tipoRecebimento: '0',
        valorRecebido: 0.00,
        valorAjustes: 0.00,
        valorDocumento: 0.00,
        valorRestante: 0.00,
        valorAberto: 0.00,
        valorRecebimentos: 0.00,
        contaId: null,
        vendedorId: null,
        baixaDireto: 'S',
        usuario: window.localStorage.getItem('login'),
        tipoChavePix: null,
        nomePagadorPix: null,
        bancoPixId: null
      },
      modalRecebimentos: {
        parametros: {
          permissao : false
        }
      },
      contasOpcoes: [],
      tableRecebimentosItens: [],
      tableRecebimentosFields: [
        {
          key: "DT_BAIXA",
          label: 'Data Recebimento', 
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: 'VL_BAIXA', 
          class:'text-right', 
          label: 'Valor Recebido (R$)', 
          formatter: (value, key, item) => 
            value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_MULTA',
          class: 'text-right',
          label: 'Multa (R$)'
        },
        {
          key: 'VL_DESCONTO',
          class: 'text-right',
          label: 'Desconto (R$)'
        },
        {
          key: "USUARIO",
          label: 'Usuário',
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right' 
        }
      ],
      somaTotalRecebido: 0.00
    }
  },
  
  computed: {

    isDark() {return this.$store.getters['tema/IS_DARK']  },
    perPage: {
      get () {
        return this.$store.getters['areceber/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('areceber/SET_PER_PAGE', Number(v) || 25)
      }
    },
    vlAreceberRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_ARECEBER) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlAjusteRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_AJUSTE) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlDocRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_DOC) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    currentPage: {
      get () {
        return this.$store.getters['areceber/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['areceber/DT1']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['areceber/DT2']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['areceber/ID']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['areceber/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['areceber/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_CLIENTE_ID", value);
      }
    },
    situacao: {
      get () {
        return this.$store.getters['areceber/SITUACAO']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_SITUACAO", value);
      }
    },
    dados: {
      get () {
        return this.$store.getters['areceber/LISTA']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_LISTA", value);
      }
    },
    totalTitulos: {
      get () {
        return this.$store.getters['areceber/TOTAL_TITULOS']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_TOTAL_TITULOS", value);
      }
    },
    totalEmDias: {
      get () {
        return this.$store.getters['areceber/TOTAL_EM_DIAS']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_TOTAL_EM_DIAS", value);
      }
    },
    totalAtrasado: {
      get () {
        return this.$store.getters['areceber/TOTAL_ATRASADO']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_TOTAL_ATRASADO", value);
      }
    },
    quantTitulos: {
      get () {
        return this.$store.getters['areceber/QUANT_TITULOS']
      }, 
      set (value) {
        this.$store.commit("areceber/SET_QUANT_TITULOS", value);
      }
    },
    /*
    lista() {
      return this.$store.getters['areceber/LISTA']
    }*/
    validouCamposGeralBaixa () {      
      let retorno = true
      if ( this.recebido.valorRecebido === null || Number(this.recebido.valorRecebido) <= 0.00 ||
           Tools.arredondarValor(this.recebido.valorRestante) < 0.00 || 
           Tools.arredondarValor(this.recebido.valorRecebimentos) < 0.00 ||
           !this.recebido.contaId ) { retorno = false}           
      return retorno     
    },
    validouCampoMotivoMulta () {      
      return true
    },
    validouCampoMotivoDesconto () {      
      return true
    },
    valMotivoEstorno () {      
      if (  this.parametrosOverlayRecebimento.motivo === ''  
         || this.parametrosOverlayRecebimento.motivo=== null
         || this.parametrosOverlayRecebimento.motivo.length <= 10)   { 
          return false 
      }
      return true
    },
    valMotivoCancelamento () {
      if (  this.cancelamento.dados.motivo === ''  
         || this.cancelamento.dados.motivo === null
         || this.cancelamento.dados.motivo.length <= 10)   { 
          return false 
      }
      return true
    }
    
  },
  methods: {
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem Contas a Receber',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'contas_receber.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'contas_receber.csv',
      });
    },
    async downloadBoleto (item) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)

      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          boletoId: item.BOLETO_ID,
          contaId: item.CONTA_BOLETO_ID
        }

        const response = await this.$http.post(`/api/protected/integrador/downloadPDFBoleto/`, body)

        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível baixar o PDF do Boleto.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

        
        

      } catch (err) {
        console.error('Erro na download da nota:', err)

        const erroMsg = err.response?.data?.erro || 'Falha inesperada ao gerar o PDF do Boleto'
        this.$root.$bvToast.toast(erroMsg, {
          title: 'Erro',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async cancelarBoleto(item) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)

      const resposta = await this.$bvModal.msgBoxConfirm(`Cancelar Boleto: ${item.BOLETO_ID} Do Cliente: ${item.NOME_CLIENTE} ?`, {
        title: 'Cancelar Boleto?',
        size: 'lg',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (resposta == false) {
        return
      }

      // Lógica para gerar boleto
      const bodyBoleto = {
        areceberId: item.SEQUENCIA,
        login: window.localStorage.getItem('login'),
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        let resultado
        try {
          resultado = await this.$http.post('/api/protected/boleto/cancelar', bodyBoleto)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
          console.error('Erro ao gerar boleto:', err)
        }

        resultado = (resultado?.data) ?? null
        if (!resultado || !resultado.sucesso) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', resultado?.erro || 'Erro desconhecido')
        }

        await this.$store.dispatch('areceber/GERAR_LISTA')
      }  finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async gerarBoleto() {

      if (!this.boleto.contaId || !this.boleto.empresaId) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Informe os dados Obrigatórios.')
        return
      }

      // Lógica para gerar boleto
      const bodyBoleto = {
        areceberIds: [{ARECEBER_ID: this.boleto.areceberId}],
        bancoContaId: this.boleto.contaId,
        memoObservacoesBoleto: '',
        edMensagemLocalPagamento: ''
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        let resultado
        try {
          resultado = await this.$http.post('/api/protected/boleto/post', bodyBoleto)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
          console.error('Erro ao gerar boleto:', err)
        }

        await this.$store.dispatch('areceber/GERAR_LISTA')

        const boletoGerado = (resultado?.data) ?? null
        if (!boletoGerado || !boletoGerado.boletosIds || boletoGerado.boletosIds.length === 0) {
          Tools.exibirMensagem(this.$store, 'Boleto', 'warning', 'Não foi possível gerar o Boleto!')
          return
        }

        const bodyGerar = {
          contaId: this.boleto.contaId,
          boletoId: boletoGerado.boletosIds[0]
        }

        try {
          resultado = await this.$http.post('/api/protected/integrador/gerarBoleto', bodyGerar)
          const boletoPDF = (resultado?.data) ?? null
          if (!boletoPDF || !boletoPDF.sucesso || !boletoPDF.pdfBase64) {
            const erro = resultado?.erro || 'Não foi possível baixar o PDF do Boleto.'
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
            return
          }

          // Converte base64 para blob
          const byteCharacters = atob(boletoPDF.pdfBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })

          // Cria a URL e abre o PDF
          const url = window.URL.createObjectURL(blob)
          window.open(url)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
          console.error('Erro ao gerar boleto:', err)
        }

        this.$refs['modal-boleto-gerar'].hide()

      }  finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    colorirDiasAtraso(valor) {
      if (valor > 0) return 'danger'
      else if (valor === 0 ) return 'warning'
      else if (valor === '') return 'info'
      else 'success'
    },
    traduzBOLETO(boleto) {
      let valor = boleto?.trim()
      switch (valor) {
        case '0': return ''
        case '1': return ''
        case '2': return ''
        case '3': return ''
        case '4': return ''
        case '5': return ''

        default:
          return ''
      }
    },
    colorirBOLETO(boleto) {
      let valor = boleto?.trim()
      switch (valor) {
        case '0': return ''
        case '1': return ''
        case '2': return 'success'
        case '3': return 'warning'
        case '4': return 'danger'
        case '5': return 'info'

        default:
          return ''
      }
    },
    classIconeBoleto(boleto) {
      let valor = boleto?.trim()
      switch (valor) {
        case '0': return ''
        case '1': return ''
        case '2': return 'fa fa-suitcase text-warning'
        case '3': return 'fa fa-lock text-success'
        case '4': return 'fa fa-minus-circle text-danger'
        case '5': return 'fa fa-exclamation-circle text-info'

        default:
          return ''
      }
      
    },
    async carregarEmpresas () {
      try {
        this.empresas.items = []
        this.empresas.options = []
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/empresa/getTodas'))
        

        const empresasAux = response?.data?? null
        if (!empresasAux) {
          throw new Error("Empresas " + err)
        }
        
        const empresasArray = [].concat(empresasAux || [])

        
        for (let emp of empresasArray) {
          this.empresas.options.push({value: emp.CODIGO, text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}`})
        }

      } catch (err) {
        console.error('Erro em carregarEmpresas:', err)
      }
    },
    
     /**************************************************************************************************
     * *************** MODAL CANCELAMENTO **************************************************************
     * *************************************************************************************************/
    async abrirModalCancelamento(titulo) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", titulo.SEQUENCIA)

      this.cancelamento.dados.titulo = titulo
      this.cancelamento.dados.id = titulo.ID
      this.cancelamento.dados.nomeCliente = titulo.NOME_CLIENTE
      this.cancelamento.dados.documento = titulo.DOCUMENTO
      this.cancelamento.dados.motivo = ''
      this.cancelamento.dados.dataVencimento = moment(String(titulo.DT_RECEB)).format('DD/MM/YYYY')
      this.cancelamento.dados.valorDocumento = titulo.VL_ARECEBER ? titulo.VL_ARECEBER.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : titulo.VL_ARECEBER
      this.cancelamento.dados.usuario = window.localStorage.getItem('login')
      this.cancelamento.parametros.busy = false
      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropExcluirAreceber'
      }

      try {
        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.modalRecebimentos.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário sem permissão para baixar recebimentos')
        }

        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    cancelar() {
      if (!this.valMotivoCancelamento) {
        this.$root.$bvToast.toast('Informe o motivo' , {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
        return
      }
      this.cancelamento.parametros.overlayBaixando = true
      let pacote = {
                      id: this.cancelamento.dados.titulo.SEQUENCIA, 
                      usuario:  window.localStorage.getItem('login'),
                      motivo: this.cancelamento.dados.motivo
                   }
      let uri = 'api/protected/areceber/delete'
      this.$http.post(uri, pacote)
      .then((response) =>{
        this.cancelamento.parametros.overlayBaixando = false
        this.$store
        .dispatch('areceber/GERAR_LISTA')
        .then(() =>{
          this.status = true // or success
        })
      })
      .then(() =>{
        this.cancelamento.parametros.overlayBaixando = false
        this.$refs['modal-cancelamento'].hide()
        this.$root.$bvToast.toast('Título cancelado com Sucessso!!!', {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
        })
      })
      .catch(err => { 
        this.$refs['modal-cancelamento'].hide()
        this.cancelamento.parametros.overlayBaixando = false
        this.$root.$bvToast.toast('Falha! Não foi possível cancelar!!! \n ' + erro.response.data , {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
      })

    },

    /* ***************************************************************************************************** 
       ***********                             METODOS DO RECEBIMENTO / ESTORNAR                 ***********
       *****************************************************************************************************/
    clearIntervalOverlayRecebimentos() {
    },
    onShownOverlayRecebimentos() {
      this.$refs.dialogOverlayRecebimentos.focus()
    },
   
    onCancelOverlayRecebimentos() {
        this.parametrosOverlayRecebimento.busy = false
    },
    async onAbrirOverlayRecebimentos(registro) {
      this.parametrosOverlayRecebimento.documento = registro.DOCUMENTO
      this.parametrosOverlayRecebimento.valor = registro.VL_BAIXA.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      this.parametrosOverlayRecebimento.parcela = registro.PARCELA
      this.parametrosOverlayRecebimento.recebidoId = registro.SEQUENCIA
      this.parametrosOverlayRecebimento.motivo = null

      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropExcluirRecebParcial'
      }

      try {
        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.modalRecebimentos.parametros.permissao = false
          this.parametrosOverlayRecebimento.processando = false
          this.parametrosOverlayRecebimento.busy = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário sem permissão')
        } else {
          this.parametrosOverlayRecebimento.processando = false
          this.parametrosOverlayRecebimento.busy = true
        }

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onEstornar() {
      if ( !this.valMotivoEstorno) {
        this.$root.$bvToast.toast('Informe o motivo!!!', {
              title: 'Aviso',
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
        })
        return
      }

      this.parametrosOverlayRecebimento.busy = true
      const estornarPayLoad = {
        recebidoId:  this.parametrosOverlayRecebimento.recebidoId,
        documento: this.parametrosOverlayRecebimento.documento,
        parcela: this.parametrosOverlayRecebimento.parcela,
        login: window.localStorage.getItem('login'),
        motivo:  this.parametrosOverlayRecebimento.motivo
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post('/api/protected/recebido/estornar', estornarPayLoad)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Estornar', 'danger', err)
          return
        }

        const recebimentosResult = await this.$http.get(`api/protected/recebido/listarrecebimentostitulo?documento=${estornarPayLoad.documento}&parcela=${estornarPayLoad.parcela}`)
        this.tableRecebimentosItens = recebimentosResult?.data ?? []
        const total = this.tableRecebimentosItens.reduce((acc, item) => acc + item.VL_BAIXA, 0)
        this.somaTotalRecebido = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})

        try {
          await this.$store.dispatch('areceber/GERAR_LISTA')
          this.status = true
        } catch {
          this.status = false
        }

        Tools.exibirMensagem(this.$store, 'Estornar', 'success', 'Documento estornado com sucesso!')
        this.parametrosOverlayRecebimento.busy = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    /************************************************************************************************** */
    limpar() {
      this.$store.commit("areceber/SET_LIMPAR", null)
    },
    clicarLinha(item) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['areceber/REGISTRO_SELECIONADO_ID']
      return item.SEQUENCIA === selId ? 'cec-row-selected' : ''
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      this.$router.push(`/movimentos/contasreceber/edit/${item.SEQUENCIA}`)
    },
    novo () {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", null)
      this.$router.push(`/movimentos/contasreceber/novo`)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return 'R$ 0,00';
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    async pesquisar() {
      if (this.modalConfirmacaoAberto) {
        return;
      }
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", null)
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$store.dispatch('areceber/GERAR_LISTA')
        
        if (result.needsConfirmation) {
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        this.status = true
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('areceber/GERAR_LISTA', { skipConfirmation: true })
        this.status = true
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Informação', 'info', 'Carregamento de resultado grande cancelado')
    },
    /*filtrar (ctx) {
      this.isBusyListagem = true
      this.$http.get(this.getURIFiltro())
        .then((data) => {
          this.items = data.data
          this.isBusyListagem = false
          this.status = true // or success
          // this.$store.dispatch('increment')
          setTimeout(() => {
            this.status = ''
          }, 1000) // to clear the status :)
        }).catch((error) => {
          if (error) {
            this.items = []
            this.status = false // or error
          }
        })
    },
    */
    clienteIdRequerido () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return ((this.clienteId && this.submmited) || (this.clienteId && !this.submmited))
      } else {
        return true
      }
    },
    imprimir (id) {
      this.isLoading = true
      this.submmited = true
      let uri = '/api/protected/relatorios/relvenda?id=' + id
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.isLoading = false
          this.submmited = false
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relVenda.pdf')
          link.download = 'relVenda.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Relatório de Vendas'
            }, 2000);
          }
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.isLoading = false
        })
    },
    abrirModalRecebimentos(titulo) {

      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", titulo.SEQUENCIA)
      let uri = this.$http.defaults.baseURL.concat(`api/protected/recebido/listarrecebimentostitulo?documento=${titulo.DOCUMENTO}&parcela=${titulo.PARCELA}` )
      let promise = this.$http.get(uri)
      promise.then((data) => {
        this.tableRecebimentosItens = data.data
        if (data) {
          let i
          let total = 0.00
          for (i = 0; i < data.data.length ; i++) {
            total += data.data[i].VL_BAIXA
          }
          this.somaTotalRecebido = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          this.$refs['modal-recebimentos'].show()
        }
      })
      .catch((error) => {
        if (error) {
          this.$root.$bvToast.toast(`Falha!!!  Não foi Possível localizar os recebimentos`, {
            title: 'Falha',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        }
      })

      
    },
    
    async abrirModalBaixar(selecao) {
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", selecao.SEQUENCIA)
      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropBaixarReceber'
      }
      let permissaoResult = null
      try {
        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.modalRecebimentos.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário sem permissão para baixar recebimentos')
        }

        try {
          await this.carregarContas()
          await this.carregarBancosPix()
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível', 'danger', err)
          return
        }

        this.modalRecebimentos.parametros.permissao = true

        this.recebido.areceberId = selecao.SEQUENCIA
        this.recebido.documento = selecao.DOCUMENTO
        this.recebido.parcela = selecao.PARCELA
        this.recebido.clienteId = selecao.COD_CLI
        this.recebido.nomeCliente = selecao.NOME_CLIENTE
        this.recebido.dataVencimento = moment(String(selecao.DT_RECEB)).format('DD/MM/YYYY')
        this.recebido.dataMovimento = moment(new Date()).format('YYYY-MM-DD') // new Date(dataAtual).toISOString().substr(0, 10).split('-').reverse().join('/')
        this.recebido.tipoRecebimento = '0'
        const { data: ajusteData } = await this.$http.get(`/api/protected/areceberAjuste/getTotalByAreceberId/${selecao.SEQUENCIA}`)

        this.recebido.valorRecebido = 0.00
        this.recebido.valorAjustes = Number(ajusteData?.total) || 0.00
        this.recebido.valorAberto = Number(selecao.VL_ARECEBER) || 0.00
        this.recebido.valorDocumento = Number(selecao.VL_DOC) || 0.00
        this.recebido.valorRecebimentos = Tools.arredondarValor((Number(selecao.VL_DOC) || 0.00) + (Number(this.recebido.valorAjustes) || 0.00) - (Number(selecao.VL_ARECEBER) || 0.00))
        this.recebido.valorRestante = 0.00
        this.recebido.vendedorId = selecao.COD_VENDEDOR
        this.recebido.dataBaixa = selecao.DT_BAIXA
        this.recebido.tipoChavePix = null
        this.recebido.nomePagadorPix = null
        this.recebido.bancoPixId = null
        this.calcularRecebimento()
        this.$refs['modal-baixar'].show()
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    focusModalReceber() {
      this.$refs.valorRecebido.$el.focus()
    },
    async abrirModalGerarBoleto(item) {
      this.boleto.areceberId    = item.SEQUENCIA
      this.boleto.documento     = item.DOCUMENTO
      this.boleto.parcela       = item.PARCELA
      this.boleto.clienteId     = item.COD_CLI
      this.boleto.empresaId     = 1
      this.boleto.nomeCliente   = item.NOME_CLIENTE
      this.boleto.contaId       = null
      this.boleto.valorRecebido = 0.00
      this.boleto.valorMulta    = 0.00
      this.boleto.valorDesconto = 0.00
      this.boleto.valorAberto   = item.VL_ARECEBER
      this.boleto.valorDocumento  = item.VL_DOC
      this.boleto.valorRestante   = 0.00
      
      this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.carregarEmpresas()
          await this.carregarContas()
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível', 'danger', err)
          return
        }

        this.$refs['modal-boleto-gerar'].show()
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      
    },
    usarRestante() {
      this.recebido.valorRecebido = (this.recebido.valorAberto)
    },
    calcularRecebimento() {
      this.recebido.valorRestante = Tools.arredondarValor(
        (Number(this.recebido.valorDocumento) || 0.00)
        - (Number(this.recebido.valorRecebimentos) || 0.00)
        - (Number(this.recebido.valorRecebido) || 0.00)
        + (Number(this.recebido.valorAjustes) || 0.00)
      )
    },
    async baixar() {

      if ( this.validouCamposGeralBaixa == false||
           this.validouCampoMotivoMulta == false ||
           this.validouCampoMotivoDesconto == false) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Preencha todos os campos obrigatórios!!!')    
        return
      }

      // Validação específica para PIX
      if (this.recebido.tipoRecebimento === '6') {
        if (!this.recebido.tipoChavePix) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o tipo de chave PIX!')    
          return
        }
      }

      let movimento = {
        contaId: this.recebido.contaId,
        dtMov: moment(this.recebido.dataMovimento).format('MM-DD-YYYY'),
        login: window.localStorage.getItem('login')
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post(`/api/protected/caixa/abrirmovimento/`, movimento)
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Operação Indisponível', 'danger', error)
          return
        }

        
        const documentoPayload = {
          ...this.recebido,
          valorMulta: 0.00,
          valorDesconto: 0.00,
          motivoMulta: null,
          motivoDesconto: null
        }
        let pacote = {documento: documentoPayload}
        try {
          await this.$http.post('api/protected/areceberbaixa/baixar', pacote)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível', 'danger', `Falha. Não foi possível concluir a Baixa do Título ${this.recebido.documento}`)
          return
        }
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Documento Baixado com Sucesso!!!')
        await this.$store.dispatch('areceber/GERAR_LISTA')
        this.$refs['modal-baixar'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async carregarContas () {
      this.contasOpcoes = []
      this.recebido.contaId = null
      try {
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/conta/listar'))
      if (response && response.data) {
        for (let conta of response.data) {
        this.contasOpcoes.push({ value: conta.ID, text: conta.CODIGONOME })
        }
      }
      const contaPadraoResp = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getcontapadrao'))
      if (contaPadraoResp && contaPadraoResp.data && contaPadraoResp.data[0]) {
        this.recebido.contaId = contaPadraoResp.data[0].COD_CONTA
      }
      } catch (error) {
          console.error('Erro em carregarContas:', error)
      }
    },
    async carregarBancosPix() {
      try {
        this.bancosPixOpcoes = []
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/banco-febraban/listar'))
        
        if (response && response.data) {
          for (let banco of response.data) {
            this.bancosPixOpcoes.push({ value: banco.ID, text: `${banco.ID} - ${banco.NOME}` })
          }
        }
      } catch (error) {
        console.error('Erro em carregarBancosPix:', error)
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.$refs.btAdicionar.click()
      } 
      
    },
    abrirPainelAnalitico() {
      this.$router.push('/movimentos/contasreceber/analytics')
    },
    // --- LÓGICA DO BAIXAR EM LOTE ---
    abrirModalBaixarLote() {
        this.lote.clienteId = null
        this.lote.nomeCliente = ''
        this.lote.titulos = []
        this.lote.valorTotalRecebido = 0.00
        this.lote.contaId = null
        this.lote.tipoRecebimento = '0'
        this.lote.dataMovimento = moment().format('YYYY-MM-DD')
        this.lote.todosSelecionados = false
        this.$refs['modal-baixar-lote'].show()
    },
    focusModalBaixarLote() {
        // Focar em algo se necessario
    },
    async onClienteSelecionadoLote(id) {
        if (this.lote.clienteId === id) return
        this.lote.clienteId = id
        if (id) {
            await this.buscarTitulosLote(id)
        } else {
            this.lote.titulos = []
            this.somarSelecionados()
        }
    },
    async buscarTitulosLote(clienteId) {
        this.lote.overlay = true
        try {
            const dt1 = '2000-01-01'
            const dt2 = '2050-01-01'
            // O usuario especificou: /api/protected/areceber/pesquisar?id=${id}&dt1=${dt1}&dt2=${dt2}&clienteId=${clienteId}
            // id aqui refere-se provavelmente a um filtro de ID especifico, vou deixar vazio pois queremos todos do cliente
            const id = '' 
            
            let uri = `/api/protected/areceber/pesquisar?id=${id}&dt1=${dt1}`+
                      `&dt2=${dt2}`+
                      `&clienteId=${clienteId}`
            
            const response = await this.$http.get(uri)
            const data = response.data || []
            
            // Mapear apenas titulos com saldo a receber
            this.lote.titulos = data.filter(t => t.VL_ARECEBER > 0).map(t => ({
                ...t,
                selecionado: false
            }))
            
        } catch (error) {
            console.error(error)
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao buscar títulos do cliente.')
        } finally {
            this.lote.overlay = false
        }
    },
    somarSelecionados() {
        const selecionados = this.lote.titulos.filter(t => t.selecionado)
        this.lote.valorTotalRecebido = selecionados.reduce((acc, curr) => acc + (parseFloat(curr.VL_ARECEBER) || 0), 0)
        
        this.lote.todosSelecionados = this.lote.titulos.length > 0 && this.lote.titulos.length === selecionados.length
    },
    toggleTodosTitulosLote() {
        const status = this.lote.todosSelecionados
        this.lote.titulos.forEach(t => t.selecionado = status)
        this.somarSelecionados()
    },
    async confirmarBaixaLote() {
        const selecionados = this.lote.titulos.filter(t => t.selecionado)
        
        if (selecionados.length === 0) {
            Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione pelo menos um título para baixar.')
            return
        }
        
        if (!this.lote.contaId) {
             Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione a Conta.')
             return
        }

        const payload = {
            usuario: window.localStorage.getItem('login'), 
            contaId: this.lote.contaId,
            dataMovimento: this.lote.dataMovimento,
            documentos: selecionados.map(t => ({
                areceberId: t.SEQUENCIA, 
                valorRecebido: t.VL_ARECEBER,
                valorDesconto: 0.00,
                valorMulta: 0.00,
                motivoMulta: "",
                motivoDesconto: "",
                tipoRecebimento: this.lote.tipoRecebimento
            })),
            adiantamentos: []
        }

        this.lote.overlay = true
        try {
            const response = await this.$http.post('/api/protected/areceberBaixa/baixarLote', payload)
            
            if (response.data && response.data.sucesso === false) {
                 throw new Error(response.data.erro || 'Erro ao processar baixa.')
            }
             
            Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Baixa em lote realizada com sucesso!')
            this.$refs['modal-baixar-lote'].hide()
            
            this.pesquisar() 
            
        } catch (error) {
            console.error(error)
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data?.erro || error.message || 'Erro ao realizar baixa em lote.')
        } finally {
            this.lote.overlay = false
        }
    }
  },
  watch: {
    'clienteId': function () {
      this.clienteIdRequerido()
    },
    'recebido.valorRecebido': function () {
      if (this.recebido.valorRecebido > this.recebido.valorAberto) {
        this.recebido.valorRecebido = this.recebido.valorAberto
      }
      this.calcularRecebimento()
    },
    'recebido.valorAjustes': function () {
      this.calcularRecebimento()
    },
  },
  async created () {
    this.$refs.dt1?.focus()
  },
  async mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown);
      
    }, 200)
    this.$nextTick(() => {
      if (this.$refs.dt1) {
        if (typeof this.$refs.dt1.focus === 'function') {
          this.$refs.dt1.focus();
        } else if (this.$refs.dt1.$el && this.$refs.dt1.$el.querySelector('input')) {
          this.$refs.dt1.$el.querySelector('input').focus();
        }
      }
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  }
}
</script>
<style>
.negrito {
  font-weight: bold !important;
}
.campo {
  width: 25%;
  font-weight: bolder;
}
.campo-titulo {
  width: 75%;
  font-weight: bolder;
  border-style: ridge;
  border: 1px solid #c2cfd6;
  background-color: #c2cfd6 !important;
}
.campo-total-moeda {
  width: 75%;
  font-weight: bolder;
  border-style: ridge;
  border: 1px solid #c2cfd6;
  background-color: #f0f3f5 !important;
}
.negrito {
  font-weight: bolder;
}
.font-vermelha {
  color: crimson !important; 
}
.font-azul {
  color: cornflowerblue !important;
}

/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}

/* premium styles */
.modal-header-premium {
  border-bottom: none;
  position: relative;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.modal-footer-premium {
  background-color: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}


</style>



<style scoped>
/* Ajustes finos para aproximar o visual da tabela ao padrão de VendaListagem */
.page-col .table.table-sm th,
.page-col .table.table-sm td {
  padding: 0.22rem 0.5rem; /* menor para reduzir altura da linha */
  vertical-align: middle;
}
.page-col .table.table-sm thead th {
  background-color: transparent; /* deixa o conteúdo em branco quando em tema claro */
}
.page-col .table.table-sm tbody tr {
  background-color: transparent !important; /* evita faixas cinza */
}
.page-col .table.table-sm tbody td {
  border-bottom: 1px solid #dcdfe0; /* linha horizontal entre registros */
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/contasreceber/AreceberListagem.vue